import { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import Header from '~/componentsPage/Header/Header';
import styles from '~/styles/AboutUs/AboutUs.module.css';

function AboutUs() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (isMenuOpen && menuRef.current && !menuRef.current.contains(e.target as Node)) {
        setIsMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isMenuOpen]);

  return (
    <div className={styles.pageContainer}>
      <Header />

      <main className={styles.aboutContent}>
        {/* HERO SECTION */}
        <section className={styles.aboutHero}>
          <div className={styles.heroBadge}>Poznaj nas bliżej</div>
          <h1>Twoje miejsce w sieci – <span>Czateria24</span></h1>
          <p>
            Łączymy ludzi, tworząc bezpieczną i nowoczesną przestrzeń do rozmów w czasie rzeczywistym.
            Czateria24 to więcej niż zwykły czat – to społeczność pełna pasji.
          </p>
        </section>

        {/* MISSION CARDS */}
        <div className={styles.missionGrid}>
          <div className={styles.infoCard}>
            <div className={styles.cardIcon}>🚀</div>
            <h3>Nowoczesność</h3>
            <p>Stale rozwijamy nasz interfejs, aby rozmowy były intuicyjne i przyjemne zarówno na komputerach, jak i urządzeniach mobilnych.</p>
          </div>

          <div className={styles.infoCard}>
            <div className={styles.cardIcon}>🛡️</div>
            <h3>Bezpieczeństwo</h3>
            <p>Dbamy o Twoją prywatność. Nasz system moderacji czuwa, aby społeczność była wolna od spamu i nieodpowiednich zachowań.</p>
          </div>

          <div className={styles.infoCard}>
            <div className={styles.cardIcon}>💬</div>
            <h3>Wolność słowa</h3>
            <p>Wierzymy w otwarty dialog. Oferujemy dziesiątki pokojów tematycznych, w których każdy znajdzie miejsce dla siebie.</p>
          </div>
        </div>

        {/* STATS SECTION */}
        <section className={styles.statsSection}>
          <div className={styles.statBox}>
          </div>
          <div className={styles.statBox}>
            <span className={styles.statNumber}>Dla każdego</span>
            <span className={styles.statLabel}>wspaniała zabawa</span>
          </div>
          <div className={styles.statBox}>
            <span className={styles.statNumber}>Ponad 1000</span>
            <span className={styles.statLabel}>Pokojów rozmów</span>
          </div>
          <div className={styles.statBox}>
            <span className={styles.statNumber}>24/7</span>
            <span className={styles.statLabel}>Dostępność</span>
          </div>
        </section>

        {/* STORY SECTION */}
        <section className={styles.storySection}>
          <div className={styles.storyText}>
            <h2>Dlaczego warto wybrać Czateria24?</h2>
            <p>
              Nasz portal powstał z myślą o prostocie. Nie potrzebujesz skomplikowanych formularzy rejestracyjnych,
              aby zacząć rozmowę. Możesz wejść jako <strong>Gość</strong> i natychmiast nawiązać nowe znajomości.
            </p>
            <ul className={styles.featureList}>
              <li>✨ Brak konieczności instalowania aplikacji</li>
              <li>✨ Intuicyjny Dark Mode dla nocnych marków</li>
              <li>✨ Możliwość prowadzenia rozmów prywatnych</li>
            </ul>
            <Link to="/" className={styles.ctaButton}>Zacznij czatować teraz</Link>
          </div>
        </section>
      </main>

      {/* FOOTER */}
      <footer className={styles.mainFooter}>
        <div className={styles.footerContent}>
          <div className={styles.footerLinks}>
            <Link to="/pomoc">Pomoc</Link>
            <Link to="/kontakt">Kontakt</Link>
            <Link to="/polityka-prywatnosci">Polityka prywatności</Link>
            <Link to="/regulamin">Regulamin</Link>
          </div>

          <div className={styles.disclaimer}>
            <p>
              Serwis <strong>Czateria24</strong> jest przeznaczony wyłącznie dla osób, które ukończyły <strong>18 lat</strong>.
              Korzystanie z portalu oznacza akceptację regulaminu oraz polityki plików cookies.
            </p>
          </div>

          <div className={styles.copyright}>
            © Czateria24. Wszystkie prawa zastrzeżone.
          </div>
        </div>
      </footer>
    </div>
  );
}

export default AboutUs;